<header class="fixed w-full bottom-[-1px] z-[9] box-shadow bg-white lg:hidden">

    <nav role="navigation">
        <ul class="grid items-center grid-cols-4">
            <li class="text-center whitespace-nowrap">
                <a matRipple routerLink="/" routerLinkActive="text-blue-500"
                    class="p-2 flex flex-col items-center relative gap-1 text-blue-500 active">
                    <i class="ico-Shop text-xl"></i>
                    <span class="font-bold text-xs">خانه</span>
                </a>
            </li>
            <li class="text-center whitespace-nowrap">
                <a matRipple (click)="openRaychat()" class="p-2 flex flex-col items-center relative gap-1">
                    <i class="ico-Message text-xl"></i>
                    <span class="font-bold text-xs"> پشتیبانی آنلاین</span>
                </a>
            </li>
            <li class="text-center whitespace-nowrap">
                <a matRipple [href]="userData ?  '/persian/userprofile/#/reserve/' : '/persian/pursuit/tracking/'"
                    routerLinkActive="text-blue-500" class="p-2 flex flex-col items-center relative gap-1">
                    <i class="ico-Suitcase text-xl"></i>
                    <span class="font-bold text-xs" *ngIf="!userData;else isReserve"> پیگیری رزرو</span>
                    <ng-template #isReserve>
                        <span class="font-bold text-xs">رزروهای من</span>
                    </ng-template>
                </a>
            </li>
            <li class="text-center whitespace-nowrap">
                <button matRipple (click)="!userData ?  openDialog() : navigate()"
                    class="p-2 flex flex-col items-center gap-1">
                    <i class="ico-ProfileCircle text-xl"></i>
                    <span class="text-xs font-bold" *ngIf="!userData; else userName">ورود | ثبت نام</span>
                    <ng-template #userName>
                        <span class="text-xs font-bold">{{ userData.FirstName ? userData.FirstName + " " +
                            userData.LastName :
                            userData.Mobile }}</span>
                    </ng-template>
                </button>
            </li>
        </ul>







    </nav>

</header>